export default __webpack_public_path__ + "static/media/BM_RenderCamera_23_CU_D+Interior+Detail+Bedroom.549e0f17.jpg";